var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogTitle, DialogContent, Card, CardContent, DialogActions, Button } from "@mui/material";
export default function ConfirmPopup(props) {
    var _a;
    function onClose(isOK) {
        props.onClose(isOK);
    }
    if (!props.isOpen)
        return null;
    return (_jsxs(Dialog, __assign({ open: true, onClose: function () { return onClose(false); } }, { children: [_jsx(DialogTitle, { children: (_a = props.title) !== null && _a !== void 0 ? _a : "Confirmation" }, void 0), _jsx(DialogContent, __assign({ sx: { minWidth: '300px' } }, { children: _jsx(Card, { children: _jsx(CardContent, { children: props.content }, void 0) }, void 0) }), void 0), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ variant: "contained", color: "warning", onClick: function () { return onClose(true); } }, { children: "Yes" }), void 0), _jsx(Button, __assign({ variant: "outlined", onClick: function () { return onClose(false); } }, { children: "No" }), void 0)] }, void 0)] }), void 0));
}
